export default {
  isMobile() {
    return window.innerWidth < 640
  },
  copy(value) {
    if (value === null) return

    navigator?.clipboard?.writeText(value)
  },

  copyAll(obj) {
    obj = JSON.stringify(obj)
      .replace('{"', '')
      .replace('"}', '')
      .replace('"', '')

    navigator?.clipboard?.writeText(obj)
  }
}